import { StoryIntroState } from '../../models/Models';
import { Paths, NavbarLink } from '../../models/Models';

const SET_FONTS_LOADED = 'SET_FONTS_LOADED';
const SET_DIGITAL_MUSEUM_CMS = 'SET_DIGITAL_MUSEUM_CMS';
const SET_POWERED_BY_PURPOSE_CMS = 'SET_POWERED_BY_PURPOSE_CMS';
const SET_BUILDING_BRIGTHER_FUTURES_CMS = 'SET_BUILDING_BRIGHTER_FUTURES_CMS';
const SET_VERIZON_BY_THE_NUMBERS_CMS = 'SET_VERIZON_BY_THE_NUMBERS_CMS';
const SET_COMMUNICATIONS_CHANGE_THE_WORLD_CMS = 'SET_COMMUNICATIONS_CHANGE_THE_WORLD_CMS';
const SET_CREDO_CMS = 'SET_CREDO_CMS';
const SET_INNOVATION_CMS = 'SET_INNOVATION_CMS';
const SET_GLOBAL = 'SET_GLOBAL';
const SET_NAVBAR = 'SET_NAVBAR_VISIBILITY';
const SET_STORY_INTRO_STATE = 'SET_STORY_INTRO_STATE';
const SET_PBP_BLOCK_SCROLL = 'SET_PBP_BLOCK_SCROLL';
const SET_CURRENT_SLIDE_DARK_BG = 'SET_CURRENT_SLIDE_DARK_BG';
const SET_ACTIVE_SLIDE_KEY = 'SET_ACTIVE_SLIDE_KEY';
const SET_ACTIVE_SLIDE_TYPE = 'SET_ACTIVE_SLIDE_TYPE';
const SET_MEDIA_PLAYING = 'SET_MEDIA_PLAYING';
const EXPLORE_CLICKED = 'EXPLORE_CLICKED';
const CREDITS_OPENED = 'CREDITS_OPENED';
const MENU_OPENED = 'MENU_OPENED';
const IS_SHOWING_CREDO_POPUP = 'IS_SHOWING_CREDO_POPUP';
const SKIP_NAVBAR_ADA = 'SKIP_NAVBAR_ADA';
const IN_FULL_SCREEN_VIDEO = 'IN_FULL_SCREEN_VIDEO';
const SET_LOADED = 'SET_LOADED';
const ADD_LOADED_OBJECT = 'ADD_LOADED_OBJECT';
const SET_HAS_VISITED_STORIES = 'SET_HAS_VISITED_STORIES';
const SET_HAS_VISITED_PBP = 'SET_HAS_VISITED_PBP';
const SET_HAS_VISITED_BBF = 'SET_HAS_VISITED_BBF';
const SET_HAS_VISITED_VBN = 'SET_HAS_VISITED_VBN';
const SET_HAS_VISITED_CCW = 'SET_HAS_VISITED_CCW';
const SET_HAS_VISITED_CREDO = 'SET_HAS_VISITED_CREDO';
const SET_HAS_VISITED_INNOVATION = 'SET_HAS_VISITED_INNOVATION';
const ADD_TO_VISITED_STORIES = 'ADD_TO_VISITED_STORIES';

export const setFontsLoaded = () => {
  return {
    type: SET_FONTS_LOADED
  };
};

export const setDigitalMuseumCMS = data => {
  return {
    type: SET_DIGITAL_MUSEUM_CMS,
    payload: data,
  };
};

export const setPoweredByPurposeCMS = data => {
  return {
    type: SET_POWERED_BY_PURPOSE_CMS,
    payload: data,
  };
};

export const setBuildingBrighterFuturesCMS = data => {
  return {
    type: SET_BUILDING_BRIGTHER_FUTURES_CMS,
    payload: data,
  };
};

export const setVerizonByTheNumbersCMS = data => {
  return {
    type: SET_VERIZON_BY_THE_NUMBERS_CMS,
    payload: data,
  };
};

export const setCommunicationsChangeTheWorldCMS = data => {
  return {
    type: SET_COMMUNICATIONS_CHANGE_THE_WORLD_CMS,
    payload: data,
  };
};

export const setCredoCMS = data => {
  return {
    type: SET_CREDO_CMS,
    payload: data,
  };
};

export const setInnovationCMS = data => {
  return {
    type: SET_INNOVATION_CMS,
    payload: data,
  };
};

export const setGlobal = data => {
  return {
    type: SET_GLOBAL,
    payload: data,
  };
};

export const setNavBarState = data => {
  return {
    type: SET_NAVBAR,
    payload: data,
  };
};

export const setStoryIntroState = data => {
  return {
    type: SET_STORY_INTRO_STATE,
    payload: data,
  };
};

export const setCurrentSlideDarkBg = data => {
  return {
    type: SET_CURRENT_SLIDE_DARK_BG,
    payload: data,
  };
};

export const setActiveSlideKey = data => {
  return {
    type: SET_ACTIVE_SLIDE_KEY,
    payload: data,
  };
};

export const setActiveSlideType = data => {
  return {
    type: SET_ACTIVE_SLIDE_TYPE,
    payload: data,
  };
};

export const setExploreClicked = data => {
  return {
    type: EXPLORE_CLICKED,
    payload: data,
  };
};

export const setMediaState = data => {
  return {
    type: SET_MEDIA_PLAYING,
    payload: data,
  };
};

export const setPBPBlockScroll = data => {
  return {
    type: SET_PBP_BLOCK_SCROLL,
    payload: data,
  };
};

export const setCreditsOpened = data => {
  return {
    type: CREDITS_OPENED,
    payload: data,
  };
};

export const setMenuOpened = data => {
  return {
    type: MENU_OPENED,
    payload: data,
  };
};

export const setIsShowingCredoPopup = data => {
  return {
    type:IS_SHOWING_CREDO_POPUP,
    payload: data,
  };
};

export const setSkipNavbarADA = data => {
  return {
    type: SKIP_NAVBAR_ADA,
    payload: data
  };
};

export const setInFullScreenVideo = data => {
  return {
    type: IN_FULL_SCREEN_VIDEO,
    payload: data,
  };
};

export const setLoaded = () => {
  return {
    type: SET_LOADED,
  };
};

export const addLoadedObject = data => {
  return {
    type: ADD_LOADED_OBJECT,
    payload: data,
  };
};

export const setHasVisitedStories = data => {
  return {
    type: SET_HAS_VISITED_STORIES,
    payload: data,
  };
};

export const setHasVisitedPBP = data => {
  return {
    type: SET_HAS_VISITED_PBP,
    payload: data,
  };
};

export const setHasVisitedBBF = data => {
  return {
    type: SET_HAS_VISITED_BBF,
    payload: data,
  };
};

export const setHasVisitedVBN = data => {
  return {
    type: SET_HAS_VISITED_VBN,
    payload: data,
  };
};

export const setHasVisitedCCW = data => {
  return {
    type: SET_HAS_VISITED_CCW,
    payload: data,
  };
};

export const setHasVisitedCredo = data => {
  return {
    type: SET_HAS_VISITED_CREDO,
    payload: data,
  };
};

export const setHasVisitedInnovation = data => {
  return {
    type: SET_HAS_VISITED_INNOVATION,
    payload: data,
  };
};

export const addToVisitedStories = data => {
  return {
    type: ADD_TO_VISITED_STORIES,
    payload: data,
  };
};

const defaultState = {
  initialized: false,
  fontsloaded: false,
  loaded: false,
  cms: {
    digitalMuseum: null,
    poweredByPurpose: null,
    buildingBrighterFutures: null,
    verizonByTheNumbers: null,
    communicationsChangeTheWorld: null,
    credo: null,
    innovation: null,
    global: null,
  },
  menus: {
    digitalMuseum: [],
    poweredByPurpose: [],
    buildingBrighterFutures: [],
    verizonByTheNumbers: [],
    theMuseum: [],
    about: [],
  },
  showNavBar: true,
  nextStory: null,
  storyIntroState: StoryIntroState.Hidden,
  exploreClicked: true,
  currentSlideDarkBg: true,
  activeSlideKey: null,
  activeSlideType: null,
  mediaPlaying: false,
  PBPBlockScroll: false,
  menuOpened: false,
  isShowingCredoPopup: false,
  shouldSkipNavbarADA: false,
  creditsOpened: false,
  inFullScreenVideo: false,
  loadedObjects: {},
  hasVisitedStories: false,
  hasVisitedPBP: false,
  hasVisitedBBF: false,
  hasVisitedVBN: false,
  hasVisitedCCW: false,
  hasVisitedCredo: false,
  hasVisitedInnovation: false,
  videoFadeTimeout:3000,
  visitedStories: [],
};

function isInitialized(cms) {
  var val = true;
  if (
    cms.digitalMuseum === null ||
    cms.poweredByPurpose === null ||
    cms.buildingBrighterFutures === null ||
    cms.verizonByTheNumbers === null ||
    cms.communicationsChangeTheWorld === null ||
    cms.credo === null ||
    cms.innovation === null ||
    cms.global === null
  ) {
    val = false;
  }
  return val;
}

function formatDigitalMuseumMenu(cmsData) {
  var links = [];
  if (cmsData) {
    for (var i = 0; i < cmsData.Stories.length; i++) {
      var story = cmsData.Stories[i];
      links.push(new NavbarLink(story.Menu.Text, `/${cmsData.Path.Text}/${story.Menu.Path}`, false, story.Menu.Key));
    }
  }
  return links;
}

function formatPoweredByPurposeMenu(cmsData) {
  var links = [];
  if (cmsData) {
    links.push(
      new NavbarLink(
        cmsData.Introduction.Title,
        `/${cmsData.Path.Text}/${cmsData.Introduction.Menu.Path}`,
        true,
        cmsData.Introduction.Key
      )
    );
    links.push(
      new NavbarLink(
        cmsData.Pulse.Menu.Text,
        `/${cmsData.Path.Text}/${cmsData.Pulse.Menu.Path}`,
        false,
        cmsData.Pulse.Key
      )
    );
    links.push(
      new NavbarLink(
        cmsData.NetworkMilestones.Menu.Text,
        `/${cmsData.Path.Text}/${cmsData.NetworkMilestones.Menu.Path}`,
        false,
        cmsData.NetworkMilestones.Key
      )
    );
    links.push(
      new NavbarLink(
        cmsData.Carousel.Menu.Text,
        `/${cmsData.Path.Text}/${cmsData.Carousel.Menu.Path}`,
        false,
        cmsData.Carousel.Key
      )
    );
  }
  return links;
}

function formatBuildingBrighterFuturesMenu(cmsData) {
  var links = [];
  if (cmsData) {
    links.push(
      new NavbarLink(cmsData.Introduction.Title, `/${cmsData.Path.Text}/${cmsData.Introduction.Menu.Path}`, true, cmsData.Introduction.Key)
    );
    if (cmsData.Pillars) {
      for (var i = 0; i < cmsData.Pillars.length; i++) {
        var pillar = cmsData.Pillars[i];
        links.push(
          new NavbarLink(pillar.Menu.Text, `/${cmsData.Path.Text}/${pillar.Menu.Path}`, false, pillar.Key)
        );
      }
    }
  }
  return links;
}

function formatVerizonByTheNumbersMenu(cmsData) {
  var links = [];
  if (cmsData) {
    links.push(
      new NavbarLink(cmsData.Introduction.Title, `/${cmsData.Path.Text}/${cmsData.Introduction.Menu.Path}`, true, cmsData.Introduction.Key)
    );
    if (cmsData.Sections) {
      for (var i = 0; i < cmsData.Sections.length; i++) {
        var section = cmsData.Sections[i];
        links.push(
          new NavbarLink(section.Menu.Text, `/${cmsData.Path.Text}/${section.Menu.Path}`, false, section.Key)
        );
      }
    }
  }
  return links;
}

function formatTheMuseumMenu(cmsData) {
  var links = [];
  if (cmsData) {
    links.push(
      new NavbarLink(
        cmsData.poweredByPurpose.Introduction.Title,
        `/${cmsData.poweredByPurpose.Path.Text}/${cmsData.poweredByPurpose.Introduction.Menu.Path}`,
        false,
        cmsData.poweredByPurpose.Introduction.Key
      )
    );
    links.push(
      new NavbarLink(
        cmsData.buildingBrighterFutures.Introduction.Title,
        `/${cmsData.buildingBrighterFutures.Path.Text}/${cmsData.buildingBrighterFutures.Introduction.Menu.Path}`,
        false,
        cmsData.buildingBrighterFutures.Introduction.Key
      )
    );
    links.push(
      new NavbarLink(
        cmsData.verizonByTheNumbers.Introduction.Title,
        `/${cmsData.verizonByTheNumbers.Path.Text}/${cmsData.verizonByTheNumbers.Introduction.Menu.Path}`,
        false,
        cmsData.verizonByTheNumbers.Introduction.Key
      )
    );
    links.push(
      new NavbarLink(
        cmsData.communicationsChangeTheWorld.Introduction.Title,
        `/${cmsData.communicationsChangeTheWorld.Introduction.Menu.Path}`,
        false,
        cmsData.communicationsChangeTheWorld.Introduction.Key
      )
    );
    links.push(
      new NavbarLink(
        cmsData.credo.Introduction.Menu.Text,
        `/${cmsData.credo.Introduction.Menu.Path}`,
        false,
        cmsData.credo.Introduction.Key
      )
    );
    links.push(
      new NavbarLink(
        cmsData.innovation.Introduction.Menu.Text,
        `/${cmsData.innovation.Introduction.Menu.Path}`,
        false,
        cmsData.innovation.Introduction.Key
      )
    );
  }
  return links;
}

function formatAboutMenu(cmsData) {
  var links = [];
  if(cmsData && 
      cmsData.digitalMuseum &&
      cmsData.digitalMuseum.Path && 
      cmsData.digitalMuseum.Path.Text && 
      cmsData.global && 
      cmsData.global.Navbar && 
      cmsData.global.Navbar.AboutText &&
      cmsData.global.Navbar.About &&
      cmsData.global.Navbar.About.Menu &&
      cmsData.global.Navbar.About.Menu.Path){
        links.push(new NavbarLink(
          cmsData.global.Navbar.AboutText,
          `/${cmsData.digitalMuseum.Path.Text}/${cmsData.global.Navbar.About.Menu.Path}`,
          true,
          cmsData.global.Navbar.About.Key
        ));
  }
  return links;
}

const mainReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_FONTS_LOADED:
      state.fontsloaded = true;
      return { ...state };
    case SET_DIGITAL_MUSEUM_CMS:
      if (action.payload.data) {
        state.cms = { ...state.cms, digitalMuseum: action.payload.data };

        if (state.cms && state.cms.digitalMuseum && state.cms.digitalMuseum.Stories) {
          state.nextStory = state.cms.digitalMuseum.Stories[0];
        }

        if (isInitialized(state.cms)) {
          state.menus.theMuseum = formatTheMuseumMenu(state.cms);
          state.menus.about = formatAboutMenu(state.cms);
          state.initialized = true;
        }

        state.menus.digitalMuseum = formatDigitalMuseumMenu(action.payload.data);
      }
      return { ...state };
    case SET_POWERED_BY_PURPOSE_CMS:
      if (action.payload.data) {
        state.cms = { ...state.cms, poweredByPurpose: action.payload.data };
        if (isInitialized(state.cms)) {
          state.menus.theMuseum = formatTheMuseumMenu(state.cms);
          state.menus.about = formatAboutMenu(state.cms);
          state.initialized = true;
        }

        state.menus.poweredByPurpose = formatPoweredByPurposeMenu(action.payload.data);
      }
      return { ...state };
    case SET_GLOBAL:
      if (action.payload.data) {
        state.cms = { ...state.cms, global: action.payload.data };
        if (isInitialized(state.cms)) {
          state.menus.theMuseum = formatTheMuseumMenu(state.cms);
          state.menus.about = formatAboutMenu(state.cms);
          state.initialized = true;
        }
      }
      return { ...state };
    case SET_BUILDING_BRIGTHER_FUTURES_CMS:
      if (action.payload.data) {
        state.cms = { ...state.cms, buildingBrighterFutures: action.payload.data };
        if (isInitialized(state.cms)) {
          state.menus.theMuseum = formatTheMuseumMenu(state.cms);
          state.menus.about = formatAboutMenu(state.cms);
          state.initialized = true;
        }

        state.menus.buildingBrighterFutures = formatBuildingBrighterFuturesMenu(
          action.payload.data
        );
      }
      return { ...state };
    case SET_VERIZON_BY_THE_NUMBERS_CMS:
      if (action.payload.data) {
        state.cms = { ...state.cms, verizonByTheNumbers: action.payload.data };
        if (isInitialized(state.cms)) {
          state.menus.theMuseum = formatTheMuseumMenu(state.cms);
          state.menus.about = formatAboutMenu(state.cms);
          state.initialized = true;
        }

        state.menus.verizonByTheNumbers = formatVerizonByTheNumbersMenu(
          action.payload.data
        );
      }
      return { ...state };
    case SET_COMMUNICATIONS_CHANGE_THE_WORLD_CMS:
      if (action.payload.data) {
        state.cms = { ...state.cms, communicationsChangeTheWorld: action.payload.data };
        if (isInitialized(state.cms)) {
          state.menus.theMuseum = formatTheMuseumMenu(state.cms);
          state.menus.about = formatAboutMenu(state.cms);
          state.initialized = true;
        }
      }
      return { ...state };
    case SET_CREDO_CMS:
      if (action.payload.data) {
        state.cms = { ...state.cms, credo: action.payload.data };
        if (isInitialized(state.cms)) {
          state.menus.theMuseum = formatTheMuseumMenu(state.cms);
          state.menus.about = formatAboutMenu(state.cms);
          state.initialized = true;
        }
      }
      return { ...state };
    case SET_INNOVATION_CMS:
      if (action.payload.data) {
        state.cms = { ...state.cms, innovation: action.payload.data };
        if (isInitialized(state.cms)) {
          state.menus.theMuseum = formatTheMuseumMenu(state.cms);
          state.menus.about = formatAboutMenu(state.cms);
          state.initialized = true;
        }
      }
      return { ...state };
    case SET_NAVBAR:
      state.showNavBar = action.payload.navbarVisibility;
      return { ...state };
    case SET_STORY_INTRO_STATE:
      if (action.payload.state) {
        state.storyIntroState = action.payload.state;
      }
      return { ...state };
    case SET_CURRENT_SLIDE_DARK_BG:
      state.currentSlideDarkBg = action.payload;
      return { ...state };
    case SET_ACTIVE_SLIDE_KEY:
      state.activeSlideKey = action.payload;
      return { ...state };
    case SET_ACTIVE_SLIDE_TYPE:
      state.activeSlideType = action.payload;
      return { ...state };
    case EXPLORE_CLICKED:
      state.exploreClicked = action.payload;
      return { ...state };
    case SET_MEDIA_PLAYING:
      state.mediaPlaying = action.payload;
      return { ...state };
    case SET_PBP_BLOCK_SCROLL:
      state.PBPBlockScroll = action.payload;
      return { ...state };
    case MENU_OPENED:
      state.menuOpened = action.payload;
      return { ...state };    
    case IS_SHOWING_CREDO_POPUP:
      state.isShowingCredoPopup = action.payload;
      return { ...state };
    case SKIP_NAVBAR_ADA:
      state.shouldSkipNavbarADA = action.payload;
      return { ...state };
    case CREDITS_OPENED:
      state.creditsOpened = action.payload;
      return { ...state };
    case IN_FULL_SCREEN_VIDEO:
      state.inFullScreenVideo = action.payload;
      return { ...state };
    case SET_LOADED:
      state.loaded = true;
      return { ...state };
    case ADD_LOADED_OBJECT:
      state.loadedObjects = { ...ADD_LOADED_OBJECT, ...action.payload };
      return { ...state };
    case SET_HAS_VISITED_STORIES:
      state.hasVisitedStories = action.payload;
      return { ...state };
    case SET_HAS_VISITED_PBP:
      state.hasVisitedPBP = action.payload;
      return { ...state };
    case SET_HAS_VISITED_BBF:
      state.hasVisitedBBF = action.payload;
      return { ...state };
    case SET_HAS_VISITED_VBN:
      state.hasVisitedVBN = action.payload;
      return { ...state };
    case SET_HAS_VISITED_CCW:
      state.hasVisitedCCW = action.payload;
      return { ...state };
    case SET_HAS_VISITED_CREDO:
      state.hasVisitedCredo = action.payload;
      return { ...state };
    case SET_HAS_VISITED_INNOVATION:
      state.hasVisitedInnovation = action.payload;
      return { ...state };
    case ADD_TO_VISITED_STORIES:
      state.visitedStories = state.visitedStories.includes(action.payload)
        ? state.visitedStories
        : [...state.visitedStories, action.payload].sort((a, b) => a - b);
      return { ...state };
    default:
      return state;
  }
};

export default mainReducer;
